import React from 'react'
import { useTranslation } from 'react-i18next';

export default function ProgressChartScoreExplain(props) {

    const { scoreLabel, shouldShowChart, embedded } = props
    let label = scoreLabel || ""

    const { t, i18n } = useTranslation(['teacher_report_chart_progress'])
    const unitDescription = scoreUnitExplain(label)

    if (embedded) return null
    if (!shouldShowChart) return null
    if (!unitDescription) return null

    if (i18n.language !== 'en-us') {
        return <div className='score-unit-explain'>
            {t(unitDescription)}
        </div>
    }

    return null
}

function scoreUnitExplain(unit) {
    switch (unit) {
        case "WCPM": 
        case "equatedWCPM": 
            return "WCPM: Words Correct Per Minute"
        case "AREA": 
            return "AREA: Amira Reading Estimated Age"
        case "High Frequency Words": 
            return "High Frequency Words (ARM Scale)"
        case "Phonological Awareness": 
            return "Phonological Awareness (ARM Scale)"
        case "EVS": 
            return "Vocabulary"
        case "ARM": 
            return "ARM: Amira Reading Mastery"
        case "ISIP SS":
            return "ISIP SS: ISIP Scaled Score"
        case "Decoding":
            return "Decoding (ARM Scale)    "
        case "Background Knowledge":
            return "Background Knowledge (ARM Scale)"
        case "Structures & Reasoning":
            return "Structures & Reasoning (ARM Scale)"
        case "Vocabulary":
            return "Vocabulary (ARM Scale)"
        default: return null
    }
}